// import * as firebase from "firebase";
import firebase from "firebase/app"

// These imports load individual services into the firebase namespace.
import 'firebase/auth';
// import 'firebase/database';
import "firebase/firestore";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
let config = {
  apiKey: "AIzaSyC3Jl0NkizSoh7K7CYBRgz2b8G-L85wv6s",
  authDomain: "paderno-ea4ef.firebaseapp.com",
  databaseURL: "https://paderno-ea4ef.firebaseio.com",
  projectId: "paderno-ea4ef",
  storageBucket: "paderno-ea4ef.appspot.com",
  messagingSenderId: "648114918604",
  appId: "1:648114918604:web:e4cd982cccc8ec0712de69"
};


firebase.initializeApp(config);

// export default firebase.firestore();
export const auth = firebase.auth();
export const firestore = firebase.firestore();

const provider = new firebase.auth.GoogleAuthProvider();
export const signInWithGoogle = () => {
  auth.signInWithPopup(provider);
};

export const generateUserDocument = async (user, additionalData) => {
  if (!user) return;

  const userRef = firestore.doc(`users/${user.uid}`);
  const snapshot = await userRef.get();

  if (!snapshot.exists) {
    const { email, displayName, photoURL } = user;
    try {
      await userRef.set({
        displayName,
        email,
        photoURL,
        ...additionalData
      });
    } catch (error) {
      console.error("Error creating user document", error);
    }
  }
  // console.log(user.uid);
  return getUserDocument(user.uid);
};

const getUserDocument = async uid => {
  if (!uid) return null;
  try {
    const userDocument = await firestore.doc(`users/${uid}`).get();

    return {
      uid,
      ...userDocument.data()
    };
  } catch (error) {
    console.error("Error fetching user", error);
  }
};
